<template>
  <v-btn-toggle class="float-right" v-model="display" mandatory>
    <v-btn value="gantt"><v-icon color="var(--theme-color-two)">mdi-format-list-bulleted</v-icon></v-btn>
    <v-btn value="calendar"><v-icon color="var(--theme-color-two)">mdi-calendar</v-icon></v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  data() {
    return {
      display: 'gantt',
    }
  },
  props: {
    value: { types: String, require: true },
  },
  created() {
    this.display = this.value
  },
  watch:{
    display(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>